import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Select, Switch } from 'antd';
import { useQuery } from '@common/hooks';
import { ErrorHandler, LoadingState } from '@common/components';
import ExpirationTypeSelect from './expiration-type-select';
import { ENUM_QUERY } from '@common/graphql';

export default function FormLicenseTemplate({
  handleSubmit,
  initialValues,
  showExpiration,
  form,
}) {
  const { data, loading, error } = useQuery(ENUM_QUERY, {
    variables: { key: 'AlliedHealthNursingLicenseType' },
  });

  if (loading) {
    return <LoadingState />;
  }

  if (error) {
    return <ErrorHandler error={error} log="FormLicenseTemplate" />;
  }

  const handleLicenseSelect = (value, { children }) => {
    form.setFieldsValue({ name: children });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      initialValues={initialValues}
    >
      <Form.Item label="Active" name="active" valuePropName="checked">
        <Switch />
      </Form.Item>
      <Form.Item
        label="License Type"
        name="licenseType"
        rules={[{ required: true, message: 'Select a document type' }]}
      >
        <Select
          size="large"
          showSearch
          onChange={handleLicenseSelect}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {data?.enum.map(({ name: id, description: name }) => (
            <Select.Option key={id} value={id}>
              {name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="Name"
        name="name"
        rules={[{ required: true, message: 'Please enter a item name' }]}
      >
        <Input size="large" />
      </Form.Item>

      {showExpiration && <ExpirationTypeSelect form={form} />}

      <Form.Item label="Description" name="description">
        <Input.TextArea />
      </Form.Item>
    </Form>
  );
}

FormLicenseTemplate.propTypes = {
  initialValues: PropTypes.shape({
    active: PropTypes.bool,
    licenseType: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  }),
  dismiss: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  showExpiration: PropTypes.bool,
};

FormLicenseTemplate.defaultProps = {
  showExpiration: false,
};
